<div class="p-grid" style="margin: 15px;">

    <!-- CONTENU TITRE BON PLAN -->
    <ng-template [ngIf]="titreBonPlan['id_contenu']">
        <p-panel  [transitionOptions]="'160ms'" [toggleable]="true" class="p-col-12"  [toggler]="'header'">
            <p-header > Titre du bon plan </p-header>
            <div class="p-grid">
                <app-description [type-contenu]="'titreBonPlan'"  [read-only]="true" [numero-contenu]="titreBonPlan['numero_contenu']" [content]="titreBonPlan['valeur_contenu']" [doute]=" titreBonPlan['doute'] "   [erreurs]=" titreBonPlan['erreurs'] " [valide]="titreBonPlan['is_valid']"  [valide-cq]="titreBonPlan['is_valid_cq']"  [erreurs-cq]=" titreBonPlan['erreurs_cq'] "  class="p-col-12"></app-description>
            </div>
        </p-panel>
    </ng-template>
    <!-- FIN CONTENU TITRE BON PLAN -->

    <!-- CONTENU PHRASE d'ACCROCHE -->
    <ng-template [ngIf]="phraseAccroche['id_contenu']">
        <p-panel  [transitionOptions]="'160ms'" [toggleable]="true" class="p-col-12"  [toggler]="'header'" >
            <p-header > Phrase d'accroche </p-header>
            <div class="p-grid">
                <app-description [type-contenu]="'phraseAccroche'"  [read-only]="true"  [numero-contenu]="phraseAccroche['numero_contenu']" [content]="phraseAccroche['valeur_contenu']" [doute]=" phraseAccroche['doute'] "   [erreurs]=" phraseAccroche['erreurs'] " [valide]="phraseAccroche['is_valid']"  [valide-cq]="phraseAccroche['is_valid_cq']"  [erreurs-cq]=" phraseAccroche['erreurs_cq'] "  class="p-col-12"></app-description>
            </div>
        </p-panel>
    </ng-template>
    <!-- FIN CONTENU PHRASE d'ACCROCHE -->


    <!-- CONTENU DETAIL -->
    <ng-template [ngIf]="detail['id_contenu']">
        <p-panel  [transitionOptions]="'160ms'" [toggleable]="true" class="p-col-12"  [toggler]="'header'" >
            <p-header > Détails du bon plan </p-header>
            <div class="p-grid">
                <app-description [type-contenu]="'detail'"  [read-only]="true"  [numero-contenu]="detail['numero_contenu']" [content]="detail['valeur_contenu']" [doute]=" detail['doute'] "   [erreurs]=" detail['erreurs'] " [valide]="detail['is_valid']"  [valide-cq]="detail['is_valid_cq']"  [erreurs-cq]=" detail['erreurs_cq'] "  class="p-col-12"></app-description>
            </div>
        </p-panel>
    </ng-template>
    <!-- FIN CONTENU DETAIL -->
    
    <!-- CONTENU SITE WEB -->
    <p-panel  *ngIf="siteWeb['id_contenu']" [transitionOptions]="'160ms'" [toggleable]="true"  class="p-col-12" [toggler]="'header'">
        <p-header > Site web </p-header>
        <app-reseaux-sociaux [read-only]="true"  [is-site]="true" [doute]="siteWeb['doute']" [lien]="siteWeb['valeur_contenu']" [valide]="siteWeb['is_valid']" [is-site]="true" [erreurs]=" siteWeb['erreurs'] "  [valide-cq]=" siteWeb['is_valid_cq'] " [erreurs-cq]=" siteWeb['erreurs_cq'] " ></app-reseaux-sociaux>
    </p-panel>
    <!-- FIN CONTENU SITE WEB -->

    <!-- CONTENU LOGO -->
    <p-panel  *ngIf="logo['id_contenu']" [transitionOptions]="'160ms'" [toggleable]="true"  class="p-col-12" [toggler]="'header'">
        <p-header > Logo </p-header>
        <app-photos [no-duplicate]="true"  [site-web]="siteWeb['valeur_contenu']" [doute]="logo['doute']" [read-only]="true" [is-logo]="true" [lien]="logo['valeur_contenu']" [valide]=" logo['is_valid'] " [is-logo]="true" [erreurs]=" logo['erreurs'] "  [valide-cq]=" logo['is_valid_cq'] " [erreurs-cq]=" logo['erreurs_cq'] "></app-photos>
    </p-panel>
    <!-- FIN CONTENU LOGO -->
 
    <!-- CONTENU RESEAUX SOCIAUX -->
    <p-panel *ngIf="reseauxSociaux.length > 0" [transitionOptions]="'160ms'" [toggleable]="true"  class="p-col-12" [toggler]="'header'">
        <p-header > Réseaux sociaux </p-header>
        <app-reseaux-sociaux *ngFor="let rs of reseauxSociaux" [read-only]="true"  [doute]="rs['doute']"  [lien]="rs['valeur_contenu']" [valide]="rs['is_valid']" [id-contenu]="rs['id_contenu']" [erreurs]=" rs['erreurs'] "  [valide-cq]=" rs['is_valid_cq'] " [erreurs-cq]=" rs['erreurs_cq'] "></app-reseaux-sociaux>
    </p-panel>
    <!-- FIN CONTENU RESEAUX SOCIAUX -->
 
 
    <!-- CONTENU DESCRIPTION -->
    <ng-template [ngIf]="description['id_contenu']">
        <p-panel  [transitionOptions]="'160ms'" [toggleable]="true" class="p-col-12"  [toggler]="'header'">
            <p-header > Description </p-header>
            <div class="p-grid">
                <app-description [read-only]="true" [doute]="description['doute']"  [erreurs]="description['erreurs']" [valide-cq]="description['is_valid_cq']" [content]="description['valeur_contenu']" [valide]="description['is_valid']" class="p-col-12" [erreurs-cq]=" description['erreurs_cq'] " ></app-description>
            </div>
        </p-panel>
    </ng-template>
    <!-- FIN CONTENU DESCRIPTION -->
    
   <!-- CONTENU PHOTO -->
   <p-panel *ngIf="photos.length > 0" [transitionOptions]="'160ms'" [toggleable]="true"  class="p-col-12" [toggler]="'header'">
    <p-header > Photos </p-header>    
    <app-photos *ngFor="let photo of photos" [read-only]="true" [doute]="photo['doute']" [lien]="photo['valeur_contenu']" [valide]=" photo['is_valid'] " [id-contenu]=" photo['id_contenu'] " [erreurs]=" photo['erreurs'] "  [valide-cq]=" photo['is_valid_cq'] "  [erreurs-cq]=" photo['erreurs_cq'] " ></app-photos>
    
</p-panel>
<!-- FIN CONTENU PHOTO -->
 
 
 </div>